import Common from "./Common";
import { NCV_DOMAIN, NETWORK, SERVICE, getService } from "./const";
import { getApiDomainByPlatform } from './url';

const DEFAULT_OPTIONS = {
  useInitCallSessionApi: true, // 초기 로드 시 session api 호출 여부
  durationMinutes: 15, // 분(min) 단위
  goErrorPage: null // string | function
};

// 커뮤니티 SDK 에러 페이지 (퍼플 런처는 런처에서 관리하는 에러 페이지로 이동함(PurpleUrl.goErrorPage))
const getErrorPageUrl = (env = NETWORK.live) => {
  const service = getService();
  const isL2mNct = service === SERVICE.L2M_NCT;
  const isL2mNcj = service === SERVICE.L2M_NCJ;
  const isL2mSa = service === SERVICE.L2M_SA;

  if(isL2mSa) {
    return `${NCV_DOMAIN[env]}/error/500`;
  }

  const domain = getApiDomainByPlatform();

  if(isL2mNct || isL2mNcj) {
    return `${domain}/support/500`;
  }
  
  return `${domain}/error/500`;
};

class SessionCheck {
  constructor(options = {}) {
    this.com = Common.instance;
    this.options = {...DEFAULT_OPTIONS, ...options};
    this.options?.useInitCallSessionApi && this.callSessionApi();
  }

  extendSession() {
    const { durationMinutes } = this.options || {};
    let timer;

    try {
        timer = setTimeout(() => {
            this.callSessionApi();
        }, durationMinutes * 60 * 1000);
    } catch(e) {
        console.error(e);
    }
  }

  callSessionApi() {
    const { env } = this.com || {};
    const apiDomain = getApiDomainByPlatform();
    const url = `${apiDomain}/api/session/check`;

    fetch(url, {
        method: 'GET',
        credentials: 'include'
    })
    .then(res => res?.json())
    .then(res => {
        const { login = false } = res || {};

        if(login) {
            this.extendSession(); // 로그인되면 DURATION 주기로 호출
        } else {
            this.goErrorPage(env);
        }
    })
    .catch(e => {
        this.extendSession(); // api 호출 실패/에러 발생 시 15분 뒤 재호출
    });
  }

  goErrorPage() {
    const { goErrorPage } = this.options;
    const { env } = this.com || {};
    
    if(typeof goErrorPage === 'string') {
      location.href = goErrorPage;
      return;
    }

    if(typeof goErrorPage === 'function') {
      goErrorPage(env);
      return;
    }

    location.href = getErrorPageUrl(env);
  }
}

export default SessionCheck;